module.exports = __webpack_public_path__ + "static/img/040_TO8_1534_og.70f00a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/040_TO8_1534_og.jpg
// module id = wlDZ
// module chunks = 0